import React from 'react';
import { CityPageDishFragment } from 'utils/gqlReactTypings.generated.d';

const MIN_RATINGS_TO_SHOW = 3;

interface IProps {
  className?: string;
  dish: CityPageDishFragment;
}

export const DishCardRating: React.FC<IProps> = ({ className, dish }) => {
  if (dish.ratingCount < MIN_RATINGS_TO_SHOW || dish.averageRating < 70) return null;
  return (
    <div className={`flex w-fit flex-row items-center gap-1 rounded bg-jackfruit-50 px-2 py-1 ${className}`}>
      <i className='fas fa-thumbs-up text-sm leading-4 text-neutral-800' />
      <span className='text-sm font-semibold leading-4 text-neutral-600'>{dish.averageRating}%</span>
      <span className='text-sm font-semibold leading-4 text-neutral-600'>{dish.ratingCount}</span>
    </div>
  );
};
